import React, { useState } from "react"
import { Text, TextField } from "letalkui"
import { Grid } from "@material-ui/core"

import { ActionDialog, AlertContainer } from "@/components"

import useValidation, { ErrorType } from "@/hooks/useValidation"

import AgentService, { CreateAgentRequest } from "@/services/AgentService"
import { InboxV2Links } from "@/utils/link"

const CreateAgentDialog: React.FC = (props) => {
	const {
		children
	} = props

	const { validation, clearValidation, triggerValidation, clearAllValidations } = useValidation()

	const [createAgentData, setCreateAgentData] = useState<CreateAgentRequest>({
		name: "",
		designation: ""
	})
	const [isCreateAgentDialogOpened, setIsCreateAgentDialogOpened] = useState<boolean>(false)

	const handleCloseCreateAgentDialog = () => {
		setIsCreateAgentDialogOpened(false)

		clearAllValidations()
	}

	const handleOpenCreateAgentDialog = () => {
		setIsCreateAgentDialogOpened(true)
	}

	const handleCreateAgent = async () => {
		try {
			const createdAgent = await AgentService.create(createAgentData)

			window.open(`${InboxV2Links.agentDetails}/${createdAgent.id}`, "_blank")

			handleCloseCreateAgentDialog()

			window.location.reload()
		} catch (error) {
			triggerValidation(error as ErrorType)
		}
	}

	const handleChangeCreateAgentData = (key: keyof CreateAgentRequest, value: string) => {
		setCreateAgentData(prev => ({ ...prev, [key]: value }))

		clearValidation(key)
	}

	return (
		<Grid>
			<Grid onClick={handleOpenCreateAgentDialog}>
				{children}
			</Grid>
			<ActionDialog
				title="Novo Agente"
				saveText="SALVAR"
				openDialog={isCreateAgentDialogOpened}
				onSave={handleCreateAgent}
				onClose={handleCloseCreateAgentDialog}
				fullWidth
			>
				<Grid container direction="column" spacing={2}>
					<Grid item>
						<AlertContainer
							alertType="info"
							title="Crie agentes de forma mais rápida"
						>
							<Text.Body type="small2">
								Defina o nome e propósito do seu agente para começar.
							</Text.Body>
						</AlertContainer>
					</Grid>

					<Grid item>
						<TextField
							label="Nome"
							subLabel="Nome que o agente irá se identificar para o cliente durante o atendimento."
							placeholder="Ex: João da Silva"
							type="text"
							value={createAgentData.name}
							onChange={({ target }) => handleChangeCreateAgentData("name", target.value)}
							fullWidth
							errorText={validation?.name as string}
						/>
					</Grid>

					<Grid item>
						<TextField
							label="Função"
							subLabel="Cargo ou área de atuação do agente"
							placeholder="Ex: Analista de marketing"
							type="text"
							value={createAgentData.designation}
							onChange={({ target }) => handleChangeCreateAgentData("designation", target.value)}
							fullWidth
							errorText={validation?.designation as string}
						/>
					</Grid>
				</Grid>
			</ActionDialog>
		</Grid>
	)
}

export default CreateAgentDialog
